<template>
    <Layout>
        <EvaluationActionText class="mr-3" />
        <Favorite v-if="canFavorite" class="flex-1 sm:flex-initial" />
        <Skip v-if="canSkip" class="flex-1 sm:flex-initial" :class="{ 'ml-3': canFavorite }" />
    </Layout>
</template>

<script>
import Layout from './Layout'
import Favorite from './Buttons/Favorite'
import Skip from './Buttons/Skip'
import EvaluationActionText from '@/components/AthleteProfile/EvaluationActionText'
import { mapState, mapGetters } from 'vuex'

export default {
    components: {
        Layout,
        Favorite,
        Skip,
        EvaluationActionText,
    },

    computed: {
        ...mapGetters('athleteProfile', ['canFavorite', 'canSkip']),
    }
}
</script>